import classNames from "classnames";
import { LoadingDots } from "PFComponents/loading_dots";
import { Option, OptionOriginal } from "PFTypes/options";
import { Ref } from "react";

import { SelectV2Props } from "../select_v2.types";
import { useDisplayValue } from "./use_display_value";
import css from "./value_container.module.scss";

type ValueContainerProps<T> = Pick<
  SelectV2Props<T>,
  "multiple" | "renderDisplayValue" | "onChange" | "locked" | "disabled"
> & {
  className?: string;
  selectedOptions: Option<T>[];
  setDisplayValueRef?: (element: HTMLDivElement | null) => void;
  isFetching: boolean;
  ref?: Ref<HTMLDivElement>;
};

export const ValueContainer = <T extends OptionOriginal = OptionOriginal>({
  multiple,
  onChange,
  renderDisplayValue,
  setDisplayValueRef,
  selectedOptions,
  className,
  isFetching,
  locked,
  disabled,
  ref
}: ValueContainerProps<T>) => {
  const { displayElement } = useDisplayValue<T>({
    selectedOptions,
    multiple,
    onChange,
    renderDisplayValue,
    setDisplayValueRef
  });

  return (
    <div
      ref={ref}
      className={classNames(className, { [css.disabled]: disabled, [css.locked]: locked })}
      tabIndex={-1}
    >
      {isFetching && <LoadingDots />}
      {!isFetching && displayElement}
    </div>
  );
};
